export const environment = {"api": "https://play.upwire.com.au/api", "external": "https://pgex-com-au-6w7rtsg45a-ts.a.run.app"};
